import React from 'react'
// eslint-disable-next-line no-unused-vars
import { Header, Item } from 'semantic-ui-react'
import 'semantic-ui-css/components/header.min.css'
import 'semantic-ui-css/components/item.min.css'
import { flatten } from 'lodash'
import JSS from '@oldscope/jss'
import { ContentfulQuery } from './ContentfulDataProvider'
import StandardizedImage from "./StandardizedImage"
import Spacing from './Spacing'

@JSS({
  ministry: {
    display: 'flex',
    alignItems: 'center',
  },
})
class Ministries extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <ContentfulQuery
        query={{
          content_type: 'ministry',
          select:
            'fields.title,fields.image,fields.website,fields.links,fields.description',
        }}
      >
        {items => (
          <Item.Group relaxed="very">
            {items.map(
              (
                { fields: { title, image, website, links, description } },
                i,
              ) => [
                <Spacing size="xlarge" key={`spacing${i}`} />,
                <Item key={`item${i}`} className={classes.ministry}>
                  <StandardizedImage
                    as={Item.Image}
                    padding="medium"
                    outlined
                    rounded
                    w={170}
                    h={140}
                    fit="pad"
                    src={image.fields.file.url}
                  />
                  <Item.Content>
                    <Item.Header style={{ fontFamily: 'inherit !important' }}>
                      {title}
                    </Item.Header>
                    <Item.Description>{description}</Item.Description>
                    <Item.Extra>
                      {[
                        <a
                          key="mainwebsite"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={website}
                        >
                          Visit Website
                        </a>,
                      ].concat(
                        flatten(
                          (links || []).map(
                            ({ sys: { id }, fields: { url, title: linkTitle } }) => [
                              <span key={`${id}-div`}>|</span>,
                              <a
                                key={id}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={url}
                              >
                                {linkTitle}
                              </a>,
                            ],
                          ),
                        ),
                      )}
                    </Item.Extra>
                  </Item.Content>
                </Item>,
              ],
            )}
          </Item.Group>
        )}
      </ContentfulQuery>
    )
  }
}

export default Ministries
